import { render, staticRenderFns } from "./LinkCardsModule.vue?vue&type=template&id=228dfdd8&"
import script from "./LinkCardsModule.vue?vue&type=script&lang=js&"
export * from "./LinkCardsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports